import { call, put, takeEvery } from 'redux-saga/effects';
import userAPI from '../../api/UserAPI';
import {
  SAVE_USER_IMPC_SELECTION_REQUEST,
  SAVE_USER_MRD_IMPC_SELECTION_REQUEST,
  SAVE_USER_CARRIER_SELECTION_REQUEST,
  SAVE_USER_HANDLER_SELECTION_REQUEST,
  SAVE_USER_MAILBOX_SELECTION_REQUEST,
  SAVE_USER_UNLOCODE_SELECTION_REQUEST,
  SAVE_USER_LAST_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATOR_IMPC_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATOR_IMPC_PRODUCT_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATORNA_IMPC_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATORNA_IMPC_PRODUCT_SELECTION_REQUEST,
  SAVE_USER_LAST_MRD_OPERATOR_IMPC_SELECTION_REQUEST,
  SAVE_USER_LAST_HANDLER_SELECTION_REQUEST,
  SAVE_USER_LAST_CARRIER_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATORNA_CARRIER_PRODUCT_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATOR_EDI_MAILBOX_SELECTION_REQUEST,
  SAVE_USER_LAST_COUNTRY_UNLOCODE_SELECTION_REQUEST,
  SAVE_USER_PRODUCT_SELECTION_REQUEST,
  SAVE_USER_REQUEST,
  FETCH_USER_DATA_REQUEST,
  SAVE_RECENT_USER_REPORT_REQUEST,
  SAVE_USER_REPORT_REQUEST,
  DELETE_SAVED_USER_REPORT_REQUEST,
  PIN_USER_REPORT_REQUEST,
  GET_LAST_SC_SETS_REQUEST,
  SAVE_DEFAULT_LAUNCH_PAGE_REQUEST,
  SAVE_USER_LAST_OPERATOR_PRODUCT_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATORNA_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATORNA_PRODUCT_SELECTION_REQUEST,
  SAVE_USER_LAST_OPERATOR_SELECTION_REQUEST,
  SAVE_USER_OPERATOR_SELECTION_REQUEST,
} from '../actions/types/UserActionTypes';
import {
  saveUserSuccessActionCreator,
  saveUserFailureActionCreator,
  saveRecentUserReportSuccessActionCreator,
  saveRecentUserReportFailureActionCreator,
  saveUserReportSuccessActionCreator,
  saveUserReportFailureActionCreator,
  deleteSavedUserReportSuccessActionCreator,
  deleteSavedUserReportFailureActionCreator,
  pinUserReportSuccessActionCreator,
  pinUserReportFailureActionCreator,
  saveLastUserSelectionFailureActionCreator,
  saveLastUserSelectionSuccessActionCreator,
  saveLastUserOperatorEdiMailboxSelectionFailureActionCreator,
  saveLastUserOperatorEdiMailboxSelectionSuccessActionCreator,
  saveLastUserOperatorImpcProductSelectionFailureActionCreator,
  saveLastUserOperatorImpcProductSelectionSuccessActionCreator,
  saveLastUserOperatorNaImpcSelectionFailureActionCreator,
  saveLastUserOperatorNaImpcSelectionSuccessActionCreator,
  saveLastUserOperatorImpcSelectionFailureActionCreator,
  saveLastUserOperatorImpcSelectionSuccessActionCreator,
  saveLastUserOperatorNaImpcProductSelectionFailureActionCreator,
  saveLastUserOperatorNaImpcProductSelectionSuccessActionCreator,
  saveLastUserMrdOperatorImpcSelectionFailureActionCreator,
  saveLastUserMrdOperatorImpcSelectionSuccessActionCreator,
  saveLastUserHandlerSelectionFailureActionCreator,
  saveLastUserHandlerSelectionSuccessActionCreator,
  saveLastUserCarrierSelectionFailureActionCreator,
  saveLastUserCarrierSelectionSuccessActionCreator,
  saveLastUserOperatorNaCarrierProductSelectionFailureActionCreator,
  saveLastUserOperatorNaCarrierProductSelectionSuccessActionCreator,
  saveLastUserCountryUnlocodeSelectionFailureActionCreator,
  saveLastUserCountryUnlocodeSelectionSuccessActionCreator,
  saveUserIMPCSelectionFailureActionCreator,
  saveUserIMPCSelectionSuccessActionCreator,
  saveUserMrdImpcSelectionFailureActionCreator,
  saveUserMrdImpcSelectionSuccessActionCreator,
  saveUserHandlerSelectionFailureActionCreator,
  saveUserHandlerSelectionSuccessActionCreator,
  saveUserCarrierSelectionFailureActionCreator,
  saveUserCarrierSelectionSuccessActionCreator,
  saveUserMailboxSelectionFailureActionCreator,
  saveUserMailboxSelectionSuccessActionCreator,
  saveUserUnlocodeSelectionFailureActionCreator,
  saveUserUnlocodeSelectionSuccessActionCreator,
  saveUserProductSelectionFailureActionCreator,
  saveUserProductSelectionSuccessActionCreator,
  fetchUserDataSuccessActionCreator,
  fetchUserDataFailureActionCreator,
  reportLastScSetsSuccessActionCreator,
  reportLastScSetsFailureActionCreator,
  saveDefaultLaunchPageSuccessActionCreator,
  saveDefaultLaunchPageFailureActionCreator,
  saveLastUserOperatorProductSelectionSuccessActionCreator,
  saveLastUserOperatorProductSelectionFailureActionCreator,
  saveLastUserOperatorNaSelectionSuccessActionCreator,
  saveLastUserOperatorNaSelectionFailureActionCreator,
  saveLastUserOperatorNaProductSelectionSuccessActionCreator,
  saveLastUserOperatorNaProductSelectionFailureActionCreator,
  saveLastUserOperatorSelectionSuccessActionCreator,
  saveLastUserOperatorSelectionFailureActionCreator,
  saveUserOperatorSelectionSuccessActionCreator,
  saveUserOperatorSelectionFailureActionCreator,
} from '../actions/UserActions';

function* saveUser() {
  try {
    yield call(userAPI.postUser);

    yield put(saveUserSuccessActionCreator());
  } catch (e) {
    yield put(saveUserFailureActionCreator(e));
  }
}

function* saveRecentUserReport(action) {
  try {
    const response = yield call(userAPI.putSaveRecentUserReport, action.payload);

    yield put(saveRecentUserReportSuccessActionCreator({
      ...action.payload,
      ...((response || {}).data || {}),
    }));
  } catch (e) {
    yield put(saveRecentUserReportFailureActionCreator(e));
  }
}

function* saveUserReport(action) {
  try {
    const response = yield call(userAPI.putSaveUserReport, action.payload);

    yield put(saveUserReportSuccessActionCreator({
      ...action.payload,
      ...((response || {}).data || {}),
    }));
  } catch (e) {
    yield put(saveUserReportFailureActionCreator(e));
  }
}

function* deleteSavedUserReport(action) {
  try {
    yield call(userAPI.deleteSavedUserReport, action.payload);
    yield put(deleteSavedUserReportSuccessActionCreator(action.payload));
  } catch (error) {
    yield put(deleteSavedUserReportFailureActionCreator(error));
  }
}

function* pinUserReport(action) {
  try {
    yield call(userAPI.putPinUserReport, action.payload);

    yield put(pinUserReportSuccessActionCreator(action.payload));
  } catch (e) {
    yield put(pinUserReportFailureActionCreator(e));
  }
}

function* saveLastUserSelection(action) {
  try {
    yield call(userAPI.putLastUserSelection, action.payload);

    yield put(saveLastUserSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserSelectionFailureActionCreator(e));
  }
}

function* saveLastUserOperatorEdiMailboxSelection(action) {
  try {
    yield call(userAPI.putLastUserOperatorEdiMailboxSelection, action.payload);

    yield put(saveLastUserOperatorEdiMailboxSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserOperatorEdiMailboxSelectionFailureActionCreator(e));
  }
}

function* saveLastUserCountryUnlocodeSelection(action) {
  try {
    yield call(userAPI.putLastUserCountryUnlocodeSelection, action.payload);

    yield put(saveLastUserCountryUnlocodeSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserCountryUnlocodeSelectionFailureActionCreator(e));
  }
}

function* saveLastUserOperatorImpcProductSelection(action) {
  try {
    yield call(userAPI.putLastUserOperatorImpcProductSelection, action.payload);

    yield put(saveLastUserOperatorImpcProductSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserOperatorImpcProductSelectionFailureActionCreator(e));
  }
}

function* saveLastUserOperatorProductSelection(action) {
  try {
    yield call(userAPI.putLastUserOperatorProductSelection, action.payload);

    yield put(saveLastUserOperatorProductSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserOperatorProductSelectionFailureActionCreator(e));
  }
}

function* saveLastUserOperatorNaImpcSelection(action) {
  try {
    yield call(userAPI.putLastUserOperatorNaImpcSelection, action.payload);

    yield put(saveLastUserOperatorNaImpcSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserOperatorNaImpcSelectionFailureActionCreator(e));
  }
}

function* saveLastUserOperatorNaSelection(action) {
  try {
    yield call(userAPI.putLastUserOperatorNaSelection, action.payload);

    yield put(saveLastUserOperatorNaSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserOperatorNaSelectionFailureActionCreator(e));
  }
}

function* saveLastUserOperatorImpcSelection(action) {
  try {
    yield call(userAPI.putLastUserOperatorImpcSelection, action.payload);

    yield put(saveLastUserOperatorImpcSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserOperatorImpcSelectionFailureActionCreator(e));
  }
}

function* saveLastUserOperatorSelection(action) {
  try {
    yield call(userAPI.putLastUserOperatorSelection, action.payload);

    yield put(saveLastUserOperatorSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserOperatorSelectionFailureActionCreator(e));
  }
}

function* saveLastUserOperatorNaImpcProductSelection(action) {
  try {
    yield call(userAPI.putLastUserOperatorNaImpcProductSelection, action.payload);

    yield put(saveLastUserOperatorNaImpcProductSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserOperatorNaImpcProductSelectionFailureActionCreator(e));
  }
}

function* saveLastUserOperatorNaProductSelection(action) {
  try {
    yield call(userAPI.putLastUserOperatorNaProductSelection, action.payload);

    yield put(saveLastUserOperatorNaProductSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserOperatorNaProductSelectionFailureActionCreator(e));
  }
}

function* saveLastUserMrdOperatorImpcSelection(action) {
  try {
    yield call(userAPI.putLastUserMrdOperatorImpcSelection, action.payload);

    yield put(saveLastUserMrdOperatorImpcSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserMrdOperatorImpcSelectionFailureActionCreator(e));
  }
}

function* saveLastUserOperatorNaCarrierProductSelection(action) {
  try {
    yield call(userAPI.putLastUserOperatorNaCarrierProductSelection, action.payload);

    yield put(saveLastUserOperatorNaCarrierProductSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserOperatorNaCarrierProductSelectionFailureActionCreator(e));
  }
}

function* saveLastUserCarrierSelection(action) {
  try {
    yield call(userAPI.putLastUserCarrierSelection, action.payload);

    yield put(saveLastUserCarrierSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserCarrierSelectionFailureActionCreator(e));
  }
}

function* saveLastUserHandlerSelection(action) {
  try {
    yield call(userAPI.putLastUserHandlerSelection, action.payload);

    yield put(saveLastUserHandlerSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveLastUserHandlerSelectionFailureActionCreator(e));
  }
}

function* saveUserIMPCSelection(action) {
  try {
    yield call(userAPI.putUserIMPCSelection, action.payload);

    yield put(saveUserIMPCSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveUserIMPCSelectionFailureActionCreator(e));
  }
}

function* saveUserOperatorSelection(action) {
  try {
    yield call(userAPI.putUserOperatorSelection, action.payload);

    yield put(saveUserOperatorSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveUserOperatorSelectionFailureActionCreator(e));
  }
}

function* saveUserMrdImpcSelection(action) {
  try {
    yield call(userAPI.putUserMrdImpcSelection, action.payload);

    yield put(saveUserMrdImpcSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveUserMrdImpcSelectionFailureActionCreator(e));
  }
}

function* saveUserCarrierSelection(action) {
  try {
    yield call(userAPI.putUserCarrierSelection, action.payload);

    yield put(saveUserCarrierSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveUserCarrierSelectionFailureActionCreator(e));
  }
}

function* saveUserHandlerSelection(action) {
  try {
    yield call(userAPI.putUserHandlerSelection, action.payload);

    yield put(saveUserHandlerSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveUserHandlerSelectionFailureActionCreator(e));
  }
}

function* saveUserMailboxSelection(action) {
  try {
    yield call(userAPI.putUserMailboxSelection, action.payload);

    yield put(saveUserMailboxSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveUserMailboxSelectionFailureActionCreator(e));
  }
}

function* saveUserUnlocodeSelection(action) {
  try {
    yield call(userAPI.putUserUnlocodeSelection, action.payload);

    yield put(saveUserUnlocodeSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveUserUnlocodeSelectionFailureActionCreator(e));
  }
}

function* saveUserProductSelection(action) {
  try {
    yield call(userAPI.putUserProductSelection, action.payload);

    yield put(saveUserProductSelectionSuccessActionCreator());
  } catch (e) {
    yield put(saveUserProductSelectionFailureActionCreator(e));
  }
}

function* fetchUserData() {
  try {
    const userDataResponse = yield call(userAPI.getUserData);
    const userData = userDataResponse.data;

    yield put(fetchUserDataSuccessActionCreator(userData));
  } catch (e) {
    yield put(fetchUserDataFailureActionCreator(e));
  }
}

function* fetchScSetData(action) {
  try {
    const userDataResponse = yield call(userAPI.getScSets, action.payload.scSets, action.payload.directionSet);
    const userData = userDataResponse.data;
    yield put(reportLastScSetsSuccessActionCreator(userData));
  } catch (e) {
    yield put(reportLastScSetsFailureActionCreator(e));
  }
}

function* saveDefaultLaunchPage(action) {
  try {
    const response = yield call(userAPI.putDefaultLaunchPage, action.payload);

    yield put(saveDefaultLaunchPageSuccessActionCreator({
      ...action.payload,
      ...((response || {}).data || {}),
    }));
  } catch (e) {
    yield put(saveDefaultLaunchPageFailureActionCreator(e));
  }
}
function* userWatcher() {
  yield takeEvery(SAVE_USER_REQUEST, saveUser);
  yield takeEvery(SAVE_RECENT_USER_REPORT_REQUEST, saveRecentUserReport);
  yield takeEvery(SAVE_USER_REPORT_REQUEST, saveUserReport);
  yield takeEvery(DELETE_SAVED_USER_REPORT_REQUEST, deleteSavedUserReport);
  yield takeEvery(PIN_USER_REPORT_REQUEST, pinUserReport);
  yield takeEvery(SAVE_USER_LAST_SELECTION_REQUEST, saveLastUserSelection);
  yield takeEvery(SAVE_USER_LAST_OPERATOR_IMPC_PRODUCT_SELECTION_REQUEST, saveLastUserOperatorImpcProductSelection);
  yield takeEvery(SAVE_USER_LAST_OPERATORNA_IMPC_SELECTION_REQUEST, saveLastUserOperatorNaImpcSelection);
  yield takeEvery(SAVE_USER_LAST_OPERATOR_IMPC_SELECTION_REQUEST, saveLastUserOperatorImpcSelection);
  yield takeEvery(SAVE_USER_LAST_OPERATORNA_IMPC_PRODUCT_SELECTION_REQUEST, saveLastUserOperatorNaImpcProductSelection);
  yield takeEvery(SAVE_USER_LAST_MRD_OPERATOR_IMPC_SELECTION_REQUEST, saveLastUserMrdOperatorImpcSelection);
  yield takeEvery(SAVE_USER_LAST_OPERATORNA_CARRIER_PRODUCT_SELECTION_REQUEST, saveLastUserOperatorNaCarrierProductSelection);
  yield takeEvery(SAVE_USER_LAST_CARRIER_SELECTION_REQUEST, saveLastUserCarrierSelection);
  yield takeEvery(SAVE_USER_LAST_HANDLER_SELECTION_REQUEST, saveLastUserHandlerSelection);
  yield takeEvery(SAVE_USER_LAST_OPERATOR_EDI_MAILBOX_SELECTION_REQUEST, saveLastUserOperatorEdiMailboxSelection);
  yield takeEvery(SAVE_USER_LAST_COUNTRY_UNLOCODE_SELECTION_REQUEST, saveLastUserCountryUnlocodeSelection);
  yield takeEvery(SAVE_USER_IMPC_SELECTION_REQUEST, saveUserIMPCSelection);
  yield takeEvery(SAVE_USER_MRD_IMPC_SELECTION_REQUEST, saveUserMrdImpcSelection);
  yield takeEvery(SAVE_USER_CARRIER_SELECTION_REQUEST, saveUserCarrierSelection);
  yield takeEvery(SAVE_USER_HANDLER_SELECTION_REQUEST, saveUserHandlerSelection);
  yield takeEvery(SAVE_USER_MAILBOX_SELECTION_REQUEST, saveUserMailboxSelection);
  yield takeEvery(SAVE_USER_UNLOCODE_SELECTION_REQUEST, saveUserUnlocodeSelection);
  yield takeEvery(SAVE_USER_PRODUCT_SELECTION_REQUEST, saveUserProductSelection);
  yield takeEvery(FETCH_USER_DATA_REQUEST, fetchUserData);
  yield takeEvery(GET_LAST_SC_SETS_REQUEST, fetchScSetData);
  yield takeEvery(SAVE_DEFAULT_LAUNCH_PAGE_REQUEST, saveDefaultLaunchPage);
  yield takeEvery(SAVE_USER_LAST_OPERATOR_PRODUCT_SELECTION_REQUEST, saveLastUserOperatorProductSelection);
  yield takeEvery(SAVE_USER_LAST_OPERATORNA_SELECTION_REQUEST, saveLastUserOperatorNaSelection);
  yield takeEvery(SAVE_USER_LAST_OPERATORNA_PRODUCT_SELECTION_REQUEST, saveLastUserOperatorNaProductSelection);
  yield takeEvery(SAVE_USER_LAST_OPERATOR_SELECTION_REQUEST, saveLastUserOperatorSelection);
  yield takeEvery(SAVE_USER_OPERATOR_SELECTION_REQUEST, saveUserOperatorSelection);
}

export default userWatcher;
